module.exports = __webpack_public_path__ + "img/Journal.73e7a0aa.svg";